import { PageTransitionWrapper } from "@/core/utils/transitions/pageTransition";
import { Outlet } from "react-router-dom";

/**
 * Layout des pages invitées (hors session).
 *
 * Accueille la route `/login` (coquille de redirection vers le SSO — la
 * redirection elle-même passe par l'adaptateur Keycloak `@/core/auth`,
 * il n'y a pas de formulaire de login maison) et sert de coquille
 * visuelle (fond brand nuit) pour les écrans publics éventuels.
 */
export function GuestLayout() {
  return (
    <div className="min-h-screen bg-brand-900 text-brand-50">
      <PageTransitionWrapper>
        <Outlet />
      </PageTransitionWrapper>
    </div>
  );
}
